// extracted by mini-css-extract-plugin
export var cancelButton = "_n5-5";
export var content = "_n5-3";
export var createButton = "_n5-6";
export var drawerContainer = "_n5-0";
export var footer = "_n5-2";
export var header = "_n5-1";
export var orderFormColumn = "_n5-4";